module.exports = __webpack_public_path__ + "6b2b21a856caa67befa0aab1e94defc0.svg";


//////////////////
// WEBPACK FOOTER
// ./images/link.svg
// module id = 94
// module chunks = 0